import React, { forwardRef, useEffect, useRef, useState } from "react";
import { IconBehavior } from "../../../../assets/icons";
import ImsIcon from "../../ImsIcon";
import BehaviorModal from "../modals/BehaviorModal";
import ToolbarButton, { ToolbarButtonProps } from "../ToolbarButton";

interface BehaviorButtonPropsSimple extends ToolbarButtonProps {
  active?: boolean;
  onPositionUpdate: (rect: DOMRect) => void;
}

const BehaviorButton = forwardRef<HTMLButtonElement, BehaviorButtonPropsSimple>(
  ({ sizes, tooltip, active = false, onPositionUpdate, ...rest }, ref) => {
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [modalOpen, setModalOpen] = useState(false);

    // Expose the button DOM node via the forwarded ref.
    React.useImperativeHandle(ref, () => buttonRef.current!);

    const updatePosition = () => {
      if (buttonRef.current) {
        const rect = buttonRef.current.getBoundingClientRect();
        onPositionUpdate(rect);
      }
    };

    const handleClick = () => {
      setModalOpen((prev) => !prev);
    };

    useEffect(() => {
      if (modalOpen && buttonRef.current) {
        updatePosition();
      }
    }, [modalOpen]);

    return (
      <>
        <ToolbarButton
          {...rest}
          ref={buttonRef}
          tooltip={tooltip}
          onClick={handleClick}
          active={modalOpen || active}
          sizes={sizes}
          icon={<ImsIcon Icon={IconBehavior} />}
        />
        <BehaviorModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          sizes={sizes}
          buttonPosition={buttonRef.current?.getBoundingClientRect()}
        />
      </>
    );
  }
);

export default BehaviorButton;
